<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="8" sm="12">
      <v-card elevation="12">
        <v-toolbar color="primary" dark flat dense>
          <v-toolbar-title>Password Reset</v-toolbar-title>
          <v-spacer />
          <v-btn text exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </v-toolbar>
        <div class="py-0">
          <v-img :src="logo" class="my-3" contain height="140" />
        </div>

        <v-form v-model="valid" v-if="!reset" @submit.prevent="resetPassword">
          <v-card-title>
            <v-icon left color="primary" class="mr-2">info</v-icon>Important
            Information.
          </v-card-title>
          <v-card-text>
            <div>
              Please enter the email address associated with your account below.
            </div>
            <div>
              A newly generated password will then be sent to your account's
              email address, please use this to sign in.
            </div>
            <div>
              You can change the generated password to one of your choosing via
              the 'Account' option from the menu once you've signed in.
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-row v-if="error">
              <v-col cols="12">
                <v-chip class="ma-2" color="error" large outlined>
                  <v-icon left>announcement</v-icon>
                  {{ message }}
                </v-chip>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="email"
                  outlined
                  prepend-inner-icon="mdi-email"
                  type="email"
                  :rules="[required('Email'), isEmail]"
                  label="Email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-4">
            <v-spacer />
            <v-btn
              block
              outlined
              color="blue darken-2"
              @click.stop="resetPassword"
              :disabled="!valid"
              >Reset Password</v-btn
            >
          </v-card-actions>
        </v-form>

        <div v-if="reset">
          <v-card-title>
            <v-icon left color="primary" class="mr-2">info</v-icon>Password
            Reset
          </v-card-title>
          <v-card-text>
            <span
              >A newly generated password has been sent to your account's email
              address, please use this to sign in.</span
            >
            <span
              >You can change the generated password to one of your choosing via
              the 'Account' option from the menu once you've signed in.</span
            >
          </v-card-text>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import checkEmail from "@/util/validation/email.js";
import { mapActions } from "vuex";

export default {
  name: "PasswordReset",
  data: () => {
    return {
      valid: false,
      email: "",
      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
      isEmail: (val) => {
        return checkEmail(val);
      },
      error: false,
      message: "",
      reset: false,
    };
  },
  computed: {
    logo() {
      return require(process.env.VUE_APP_LOGO_MAIN);
    },
  },
  methods: {
    ...mapActions(["passwordResetAction"]),
    resetPassword() {
      const params = Object.assign(
        {},
        { identity: "nws9987" },
        { email: this.email.trim() }
      );
      this.error = false;
      this.passwordResetAction(params)
        .then((response) => {
          if (response == "reset-success") {
            this.error = false;
            this.reset = true;
          }
        })
        .catch((msg) => {
          this.error = true;
          this.message = msg;
        });
    },
  },
};
</script>